module.exports = __webpack_public_path__ + "static/img/badge-trap-active-mandatory-irregular.48dbe4d.svg";